/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { VirtualTimeSeriesRecord } from '../models/virtual-time-series-record';
@Injectable({
  providedIn: 'root',
})
class VirtualTimeSeriesService extends __BaseService {
  static readonly VirtualTimeSeriesGetVirtualSeriesPath = '/api/VirtualTimeSeries/GetVirtualTimeSeries/{customerId}/{siteTypeId}';
  static readonly VirtualTimeSeriesCreateVirtualTimeSeriesPath = '/api/VirtualTimeSeries/CreateVirtualTimeSeries';
  static readonly VirtualTimeSeriesUpdateVirtualTimeSeriesPath = '/api/VirtualTimeSeries/UpdateVirtualTimeSeries';
  static readonly VirtualTimeSeriesDeleteVirtualTimeSeriesPath = '/api/VirtualTimeSeries/DeleteVirtualTimeSeries';
  static readonly VirtualTimeSeriesParseExpressionPath = '/api/VirtualTimeSeries/ParseExpression';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `VirtualTimeSeriesService.VirtualTimeSeriesGetVirtualSeriesParams` containing the following parameters:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  VirtualTimeSeriesGetVirtualSeriesResponse(params: VirtualTimeSeriesService.VirtualTimeSeriesGetVirtualSeriesParams): __Observable<__StrictHttpResponse<Array<VirtualTimeSeriesRecord>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/VirtualTimeSeries/GetVirtualTimeSeries/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteTypeId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<VirtualTimeSeriesRecord>>;
      })
    );
  }
  /**
   * @param params The `VirtualTimeSeriesService.VirtualTimeSeriesGetVirtualSeriesParams` containing the following parameters:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  VirtualTimeSeriesGetVirtualSeries(params: VirtualTimeSeriesService.VirtualTimeSeriesGetVirtualSeriesParams): __Observable<Array<VirtualTimeSeriesRecord>> {
    return this.VirtualTimeSeriesGetVirtualSeriesResponse(params).pipe(
      __map(_r => _r.body as Array<VirtualTimeSeriesRecord>)
    );
  }

  /**
   * @param vts undefined
   */
  VirtualTimeSeriesCreateVirtualTimeSeriesResponse(vts: VirtualTimeSeriesRecord): __Observable<__StrictHttpResponse<VirtualTimeSeriesRecord>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = vts;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/VirtualTimeSeries/CreateVirtualTimeSeries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VirtualTimeSeriesRecord>;
      })
    );
  }
  /**
   * @param vts undefined
   */
  VirtualTimeSeriesCreateVirtualTimeSeries(vts: VirtualTimeSeriesRecord): __Observable<VirtualTimeSeriesRecord> {
    return this.VirtualTimeSeriesCreateVirtualTimeSeriesResponse(vts).pipe(
      __map(_r => _r.body as VirtualTimeSeriesRecord)
    );
  }

  /**
   * @param vts undefined
   */
  VirtualTimeSeriesUpdateVirtualTimeSeriesResponse(vts: VirtualTimeSeriesRecord): __Observable<__StrictHttpResponse<VirtualTimeSeriesRecord>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = vts;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/VirtualTimeSeries/UpdateVirtualTimeSeries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VirtualTimeSeriesRecord>;
      })
    );
  }
  /**
   * @param vts undefined
   */
  VirtualTimeSeriesUpdateVirtualTimeSeries(vts: VirtualTimeSeriesRecord): __Observable<VirtualTimeSeriesRecord> {
    return this.VirtualTimeSeriesUpdateVirtualTimeSeriesResponse(vts).pipe(
      __map(_r => _r.body as VirtualTimeSeriesRecord)
    );
  }

  /**
   * @param params The `VirtualTimeSeriesService.VirtualTimeSeriesDeleteVirtualTimeSeriesParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  VirtualTimeSeriesDeleteVirtualTimeSeriesResponse(params: VirtualTimeSeriesService.VirtualTimeSeriesDeleteVirtualTimeSeriesParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.id != null) __params = __params.set('id', params.id.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/VirtualTimeSeries/DeleteVirtualTimeSeries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `VirtualTimeSeriesService.VirtualTimeSeriesDeleteVirtualTimeSeriesParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   */
  VirtualTimeSeriesDeleteVirtualTimeSeries(params: VirtualTimeSeriesService.VirtualTimeSeriesDeleteVirtualTimeSeriesParams): __Observable<Blob> {
    return this.VirtualTimeSeriesDeleteVirtualTimeSeriesResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param expression undefined
   */
  VirtualTimeSeriesParseExpressionResponse(expression?: null | string): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (expression != null) { __formData.append('expression', expression as unknown as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/VirtualTimeSeries/ParseExpression`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @param expression undefined
   */
  VirtualTimeSeriesParseExpression(expression?: null | string): __Observable<Array<string>> {
    return this.VirtualTimeSeriesParseExpressionResponse(expression).pipe(
      __map(_r => _r.body as Array<string>)
    );
  }
}

module VirtualTimeSeriesService {

  /**
   * Parameters for VirtualTimeSeriesGetVirtualSeries
   */
  export interface VirtualTimeSeriesGetVirtualSeriesParams {
    siteTypeId: number;
    customerId: number;
  }

  /**
   * Parameters for VirtualTimeSeriesDeleteVirtualTimeSeries
   */
  export interface VirtualTimeSeriesDeleteVirtualTimeSeriesParams {
    id?: number;
    customerId?: number;
  }
}

export { VirtualTimeSeriesService }
